module.exports = __webpack_public_path__ + "img/ic_announce.45f78eb9.svg";